import styled from 'styled-components'

export const Header = styled.header`
  position: relative;
  width: 100%;
`

export const Slot = styled.div``
